import React, { memo } from 'react'
import map from 'ramda/src/map'
import withStyles from '@material-ui/core/styles/withStyles'
import Terms from 'root/src/client/web/base/StaticLayout'
import Header from 'root/src/client/web/typography/Header'
import styles from './style'
import pageContent from './pageContent'

const TermsOfService = memo(({ classes }) => (
	<Terms>
		<Header>Rules for your use of Dare Drop</Header>
		{map(
			({ title, text, paragraph, id = null }) => (
				<section className={classes.section} key={title} id={id}>
					<h3 className={classes.sectionTitle}>{title}</h3>
					<p className={classes.mainParagraph}>{paragraph}</p>
					{text}
				</section>
			),
			pageContent(classes),
		)}
		<p className={classes.info}>
			These updated terms will go into effect on November 3, 2023, at 12 a.m. Eastern
			Time, and apply to all Dares launched on Dare Drop on or after that date.
		</p>
	</Terms>
))

export default withStyles(styles, { name: 'MuiTermsOfService' })(TermsOfService)
